import React, { useEffect, useState } from 'react';
import images from '../../assets/images';
import axiosInstance from '../../Axios';
import Const from '../../config/const';
import Toast from '../../services/Toast';
import './AllProduct.css';

const AllProduct: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState<any>(null);
  const [applications, setApplications] = useState<any>([]);
  const [allApplications, setALLApplications] = useState<any>([]);
  const getApplications = async () => {
    try {
      setLoading(true);
      const application = await axiosInstance.get('/auth/applications');
      setLoading(false);
      setApplications(application.data.data);
    } catch (e) {
      setLoading(false);
      console.error(e);
      Toast.error('There was a problem loading applications.');
    }
  };
  const getAllApplications = () => {
    return [
      {
        'appName': 'LinenTech',
        'description': 'Your 360° Commercial Laundry Software',
        'key': 'linentech',
        'buttonText': 'Laundry Management',
        'icon': images.linenTechMark,
        'accentColor': '#6366f1',
        'gradientFrom': '#6366f1',
        'gradientTo': '#8b5cf6',
      },
      {
        'appName': 'LinenConnect',
        'description': 'Connect & Collaborate Seamlessly',
        'key': 'linenconnect',
        'buttonText': 'Communication Hub',
        'icon': images.linenConnectLogo,
        'accentColor': '#f59e0b',
        'gradientFrom': '#f59e0b',
        'gradientTo': '#f97316',
      },
      {
        'appName': 'LinenDesk',
        'description': 'Support portal for LinenTech clients',
        'key': 'linendesk',
        'buttonText': 'Support Portal',
        'icon': images.linenDeskLogo,
        'accentColor': '#ec4899',
        'gradientFrom': '#ec4899',
        'gradientTo': '#f43f5e',
      },
      {
        'appName': 'LinenCrew',
        'description': 'Built for laundry plant employees.',
        'key': 'linencrew',
        'buttonText': 'Workforce Management',
        'icon': images.linenCrewLogo,
        'accentColor': '#8b5cf6',
        'gradientFrom': '#8b5cf6',
        'gradientTo': '#a855f7',
      },
      {
        'appName': 'Equipmate',
        'description': 'Simplify Equipment Health Tracking & Reduce Downtime',
        'key': 'equipmate',
        'buttonText': 'Laundry Management',
        'icon': images.equipmateLogo,
        'accentColor': '#3b82f6',
        'gradientFrom': '#3b82f6',
        'gradientTo': '#06b6d4',
      },
      {
        'appName': 'LinenIq',
        'description': 'RFID Linen Tracking System',
        'key': 'linenIq',
        'buttonText': 'Laundry Management',
        'icon': images.linenIqLogo,
        'accentColor': '#10b981',
        'gradientFrom': '#10b981',
        'gradientTo': '#14b8a6',
      },
    ];
  };
  useEffect(() => {
    if (applications.length === 0) {
      getApplications();
    }
    const defaultApplications = getAllApplications();
    setALLApplications(defaultApplications);
  }, [applications]);
  const loginProduct = async (productName: string) => {
    try {
      setLoading(true);
      setProduct(productName);
      const response = await axiosInstance.post('/product/get-token', { application: productName.toLowerCase() });
      const ott = encodeURIComponent(response.data.data);
      setLoading(false);
      window.open(Const[productName] + `?ott=${ott}`, '_blank');
    } catch (error: any) {
      setLoading(false);
    }
  };
  const isAccess = (applicationKey: string) => {
    for (let i = 0; i < applications.length; i++) {
      const apiName = applications[i].name?.toLowerCase().replace(/[-_\s]/g, '');
      const keyName = applicationKey.toLowerCase().replace(/[-_\s]/g, '');
      if (apiName === keyName) {
        return false; // User HAS access
      }
    }
    return true; // Access denied
  };
  return (
    <div className="products-showcase">
      <div className="products-grid">
        {allApplications && applications && allApplications.map((application: any, index: number) => {
          const access = isAccess(application.key);
          return (
            <button
              key={application.key}
              title={access ? "Access Denied" : ""}
              disabled={loading || access}
              onClick={() => loginProduct(application.key)}
              className={`product-card-btn ${access ? 'product-card-btn--locked' : ''}`}
              data-cy={`product-card-${application.key}`}
              style={{ 
                '--accent': application.accentColor,
                '--gradient-from': application.gradientFrom,
                '--gradient-to': application.gradientTo,
                '--delay': `${index * 0.1}s`
              } as React.CSSProperties}
            >
              <div className="product-card">
                <div className="product-card__glow" />
                <div className="product-card__border" />
                
                <div className="product-card__header">
                  <div className="product-card__icon-container">
                    <div className="product-card__icon-bg" />
                    <img src={application.icon} alt={application.appName} className="product-card__icon" />
                  </div>
                  {access && (
                    <div className="product-card__lock-badge">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C9.243 2 7 4.243 7 7v3H6a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2v-8a2 2 0 00-2-2h-1V7c0-2.757-2.243-5-5-5zm0 2c1.654 0 3 1.346 3 3v3H9V7c0-1.654 1.346-3 3-3zm0 10a2 2 0 110 4 2 2 0 010-4z"/>
                      </svg>
                    </div>
                  )}
                </div>

                <div className="product-card__body">
                  <h3 className="product-card__title">{application.appName}</h3>
                  <p className="product-card__description">{application.description}</p>
                </div>

                <div className="product-card__footer">
                  <span className="product-card__category">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="3" width="7" height="7"/>
                      <rect x="14" y="3" width="7" height="7"/>
                      <rect x="14" y="14" width="7" height="7"/>
                      <rect x="3" y="14" width="7" height="7"/>
                    </svg>
                    {application.buttonText}
                  </span>
                  
                  <div className="product-card__action">
                    {loading && product === application.key ? (
                      <div className="product-card__spinner">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <circle cx="12" cy="12" r="10" strokeOpacity="0.25"/>
                          <path d="M12 2a10 10 0 0 1 10 10" strokeLinecap="round"/>
                        </svg>
                      </div>
                    ) : access ? (
                      <span className="product-card__locked-text">Locked</span>
                    ) : (
                      <span className="product-card__launch">
                        Launch
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M5 12h14"/>
                          <path d="m12 5 7 7-7 7"/>
                        </svg>
                      </span>
                    )}
                  </div>
                </div>

                {access && <div className="product-card__overlay" />}
              </div>
            </button>
          );
        })}

        <div className="product-card-btn product-card-btn--coming-soon">
          <div className="product-card product-card--coming-soon">
            <div className="coming-soon__pattern">
              <div className="coming-soon__circle coming-soon__circle--1" />
              <div className="coming-soon__circle coming-soon__circle--2" />
              <div className="coming-soon__circle coming-soon__circle--3" />
            </div>
            
            <div className="coming-soon__content">
              <div className="coming-soon__icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
              </div>
              <h3 className="coming-soon__title">Coming Soon</h3>
              <p className="coming-soon__text">
                Exciting new products are on the horizon. Stay tuned!
              </p>
              <div className="coming-soon__dots">
                <span /><span /><span />
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AllProduct;
